import ClientUssdCard from '@/components/client/client-ussd-card';
import {
	$appendClientDetailUssds,
	$clientDetailUssds,
	$setClientDetailUssds,
	type IPhone,
} from '@/entities/client.entity';
import { SOCKET_EVENTS } from '@/api/socket-events';
import { useClientVirtualFeed } from '@/hooks/use-client-virtual-feed';
import { phoneMatchesQuery } from '@/lib/format-phone';
import { getMockUssdsForClient, paginateMockItems } from '@/mocks/fixtures';
import { useUnit } from 'effector-react';

interface ClientUssdListProps {
	clientId: string;
	searchText: string;
	enabled: boolean;
	phones?: IPhone[];
	onCopy: (text: string) => void;
}

export default function ClientUssdList({ clientId, searchText, enabled, phones, onCopy }: ClientUssdListProps) {
	const [ussds, setUssds, appendUssds] = useUnit([$clientDetailUssds, $setClientDetailUssds, $appendClientDetailUssds]);

	const { listRef, content } = useClientVirtualFeed({
		clientId,
		searchText,
		enabled,
		fetchEvent: SOCKET_EVENTS.getClientUssds,
		responseEvent: SOCKET_EVENTS.addClientUssds,
		items: ussds,
		setItems: setUssds,
		appendItems: appendUssds,
		getItemId: item => item.id,
		emptyLabel: 'USSD нет',
		renderItem: ussd => <ClientUssdCard ussd={ussd} phones={phones} onCopy={onCopy} />,
		devMockFetch: ({ cursor, searchText: q }) => {
			const page = paginateMockItems(
				getMockUssdsForClient(clientId),
				{ cursor, searchText: q },
				(item, query) =>
					(item.operator?.toLowerCase().includes(query) ?? false) ||
					(item.usedCommand?.toLowerCase().includes(query) ?? false) ||
					(item.response?.toLowerCase().includes(query) ?? false) ||
					phoneMatchesQuery(item.phone, q),
			);
			return { clientId, ...page };
		},
	});

	return (
		<div ref={listRef} data-scroll-container className='h-full overflow-auto pr-1 px-1'>
			{content}
		</div>
	);
}
